/*
  ============================================================================
  bb-guide-modal.js — apre la guida di montaggio in un pannello

  COME SI AGGANCIA
  Qualsiasi elemento con data-bb-guide="<url del pdf>" apre il pannello. Il
  titolo arriva da data-bb-guide-title. Non serve altro markup nella pagina:
  il <dialog> lo crea questo file la prima volta che serve.

  SE IL BROWSER NON HA <dialog>
  Non si fa niente e il click segue il link come prima, cioe' apre il PDF in
  una scheda nuova. Meglio un comportamento vecchio che un bottone morto.
  ============================================================================
*/
(function () {
  'use strict';

  var dlg = null;

  function supportato() {
    return typeof HTMLDialogElement === 'function' &&
           typeof document.createElement('dialog').showModal === 'function';
  }

  function crea() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'bb-gm';
    dlg.innerHTML =
      '<div class="bb-gm__in">' +
        '<div class="bb-gm__head">' +
          '<h2 class="bb-gm__t"><span class="bb-gm__k">Installation guide</span>' +
            '<span data-gm-title></span></h2>' +
          '<button type="button" class="bb-gm__x" data-gm-close aria-label="Close">' +
            '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" ' +
            'stroke-width="1.6" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="bb-gm__body"><iframe class="bb-gm__frame" title="Installation guide" ' +
          'data-gm-frame></iframe></div>' +
        '<div class="bb-gm__foot">' +
          '<p class="bb-gm__note">Fitting is a workshop job. Installed parts cannot be returned.</p>' +
          '<a class="bb-tm__btn bb-tm__btn--ghost" data-gm-open target="_blank" rel="noopener">Open in a new tab</a>' +
          '<a class="bb-tm__btn bb-tm__btn--ghost" data-gm-dl download>Download PDF</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(dlg);

    // Chiudere: la X, il fondale, e il tasto Esc che lo fa gia' il browser.
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-gm-close]')) { chiudi(); return; }
      // Un click sul <dialog> stesso e' il fondale: il contenuto e' dentro __in.
      if (e.target === dlg) chiudi();
    });
    /*
      NON ci si puo' appoggiare all'evento 'close' per svuotare l'iframe:
      provato qui, chiamando close() da codice quell'evento non arriva, e il
      PDF restava caricato in memoria a pannello chiuso. Quindi si svuota
      dentro chiudi(), e l'evento resta agganciato solo per i casi in cui il
      browser chiude da solo, per esempio col tasto Esc.
    */
    dlg.addEventListener('close', svuota);
    dlg.addEventListener('cancel', svuota);
    return dlg;
  }

  function svuota() {
    if (!dlg) return;
    var f = dlg.querySelector('[data-gm-frame]');
    if (f) f.removeAttribute('src');
  }

  function chiudi() {
    svuota();
    if (dlg && dlg.open) dlg.close();
  }

  function apri(url, titolo) {
    var d = crea();
    d.querySelector('[data-gm-title]').textContent = titolo || 'PDF';
    d.querySelector('[data-gm-frame]').setAttribute('src', url);
    d.querySelector('[data-gm-open]').setAttribute('href', url);
    d.querySelector('[data-gm-dl]').setAttribute('href', url);
    d.showModal();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var t = e.target.closest('[data-bb-guide]');
    if (!t) return;
    var url = t.getAttribute('data-bb-guide');
    if (!url || !supportato()) return;   // senza <dialog> il link fa il suo giro
    e.preventDefault();
    apri(url, t.getAttribute('data-bb-guide-title') || '');
  });
})();
